<div class="template-area-details" [formGroup]="detailsFormGroup">
  <div class="details-grid">
    <sc-dictionary-field [model]="details.title" [defaultLabel]="'title'" style="grid-column: 1; grid-row: 1;"
      (dictionaryChanged)="onTitleDataDictionaryChanged($event)"
      [labelDictionaryKey]="'tmc-yard.entity.document-template-area.title'" [required]="false" [maxlength]="255">
    </sc-dictionary-field>
    <sc-dictionary-field [model]="details.help" [defaultLabel]="'help'" style="grid-column: 1; grid-row: 2;"
      (dictionaryChanged)="onHelpDataDictionaryChanged($event)"
      [labelDictionaryKey]="'tmc-yard.entity.document-template-area.help'" [required]="false" [maxlength]="255">
    </sc-dictionary-field>
    <mat-form-field style="grid-column: 1; grid-row: 3;" appearance="fill">
      <mat-label>
        <sc-dictionary-label dictionaryKey="tmc-yard.entity.document-template-area.column-count"></sc-dictionary-label>
      </mat-label>
      <input matInput name="columnCount" formControlName="columnCount" type="number" appPositiveInteger
        [required]="true" [maxLength]="255">
      </mat-form-field>
      <mat-form-field style="grid-column: 1; grid-row: 4;" appearance="fill">
        <mat-label>
          <sc-dictionary-label dictionaryKey="tmc-yard.entity.document-template-area.choice"></sc-dictionary-label>
        </mat-label>
        <mat-select formControlName="choice">
          <mat-option value="{{null}}">
            {{''}}
          </mat-option>
          @for (t of choiceOptions; track t) {
            <mat-option value="{{t}}">
              <sc-dictionary-label dictionaryKey="tmc-yard.entity.document-template-area.choice.{{t}}"></sc-dictionary-label>
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field style="grid-column: 1; grid-row: 5;" appearance="fill">
        <mat-label>
          <sc-dictionary-label dictionaryKey="tmc-yard.entity.document-template-area.style"></sc-dictionary-label>
        </mat-label>
        <input matInput name="style" formControlName="style"
          [required]="true" [maxLength]="255">
        </mat-form-field>
        <div style="grid-column: 1; grid-row: 6;" class="align-right">
          <button mat-flat-button (click)="deleteArea()">
            <sc-icon iconClass="fa-trash"></sc-icon>
          </button>
        </div>
      </div>
    </div>
